/*
 *'use strict';
 */

import 'core-js/es/object';
import 'core-js/es/typed-array';
import 'core-js/es/object';
import 'core-js/es/set';
import Cookies from 'universal-cookie';
import React from 'react';
import getAmplifyConfiguration from './amplifyConfiguration';

import axios from 'axios';
// eslint-disable-next-line
import { clearFromStorage } from 'mobile-crisis/src/utils/utils';
import { FILTERS_STORAGE_KEY } from 'mobile-crisis/src/constants/intakeHistory';
import { FILTERS_STORAGE_KEY as FILTER_STORAGE_KEY_FOLLOWUP } from 'mobile-crisis/src/constants/followUp';
import { trackEvent } from '@shared/helpers';
class AccountSelector extends React.Component {
    constructor(props) {
        super(props);

        this.csrf = props.csrf;

        this.state = {
            accountList: [],
            activeTooltip: null,
            errorMessage: '',
        };
    }

    componentDidMount() {
        //fetch and update users
        this.fetchAccountList();
    }

    fetchAccountList = () => {
        const axiosConfig = {
            headers: {
                Accept: 'application/json',
            },
            withCredentials: true,
        };
        axios
            .get(route('login.getAvailableAccounts'), axiosConfig)
            .then(async (response) => {
                if (response.data.status === 'SUCCESS') {
                    this.setState({ accountList: response.data.data });
                } else {
                    trackEvent(
                        'Login - Error Message',
                        {
                            extra: {
                                message: 'Failed to load accounts',
                                loginType: 'multiAccount',
                            },
                        },
                        () => {
                            this.setState({
                                errorMessage: 'An error occurred while loading accounts. Please try again.',
                            });
                        }
                    );
                }
            })
            .catch((error) => {
                trackEvent(
                    'Login - Error Message',
                    {
                        extra: {
                            message: error.message,
                            loginType: 'multiAccount',
                        },
                    },
                    () => {
                        this.setState({ errorMessage: 'An error occurred while loading accounts. Please try again.' });
                    }
                );
            });
    };

    //On click of a user -> make a post to backend to signin to this user_id
    handleSelectUser = async (userId) => {
        clearFromStorage(FILTERS_STORAGE_KEY, sessionStorage);
        clearFromStorage(FILTER_STORAGE_KEY_FOLLOWUP, sessionStorage);
        let data = new FormData();
        data.append('user_selected', userId);

        let csrf = this.csrf;
        data.append('csrfToken', csrf);

        const axiosConfig = {
            headers: {
                Accept: 'application/json',
            },
            withCredentials: true,
        };
        axios
            .post(route('login.select_account'), data, axiosConfig)
            .then(async (response) => {
                if (response.data.status === 'SUCCESS') {
                    const cookies = new Cookies();
                    const authConfig = getAmplifyConfiguration();
                    cookies.remove('crossAppSigninNoRedirect', {
                        domain: authConfig.cookieStorage.domain,
                        path: '/',
                        secure: authConfig.cookieStorage.secure,
                    });
                    data = response.data.data;
                    trackEvent(
                        'Login',
                        {
                            extra: {
                                loginType: 'multiAccount',
                            },
                        },
                        () => {
                            window.location.href = response.data.data.redirectUri;
                        }
                    );
                    this.setState({
                        showLoader: false,
                    });
                } else {
                    trackEvent(
                        'Login - Error Message',
                        {
                            extra: {
                                message: response.data.data.message,
                                loginType: 'multiAccount',
                            },
                        },
                        () => {
                            this.setState({
                                showSigningInScreen: false,
                                errorMessage: response.data.data.message,
                            });
                        }
                    );
                }
            })
            .catch((error) => {
                trackEvent(
                    'Login - Error Message',
                    {
                        extra: {
                            message: error.message,
                            loginType: 'multiAccount',
                        },
                    },
                    () => {
                        this.setState({
                            errorMessage: 'An error occurred while selecting the account. Please try again.',
                        });
                    }
                );
            });
    };

    hideTooltip = () => {
        this.setState({ activeTooltip: null });
    };

    render() {
        return (
            <React.Fragment>
                <div className="container" role="main">
                    <div className="row">
                        <div className="col-md-12 loginForm">
                            {this.state.errorMessage !== '' ? (
                                <div className="alert alert-danger">{this.state.errorMessage}</div>
                            ) : null}
                            <section>
                                <div className="container user-list-container" role="main">
                                    <div className="row">
                                        <div className="col-md-12 heading-sec user-list-title">
                                            <h4>
                                                <i className="fa fa-users" aria-hidden="true"></i>&nbsp; Select An
                                                Account
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="row user-list-content">
                                        <form
                                            className="form-horizontal"
                                            autoComplete="off"
                                            method="post"
                                            id="account-selector-form"
                                        >
                                            {this.renderAccountRows()}
                                        </form>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderAccountRows = () => {
        let panels = [];
        let accountList = this.state.accountList;
        for (let i = 0; i < accountList.length; i++) {
            panels.push(
                <div
                    key={`account_select_panel_${accountList[i].user_id}`}
                    className="user-list-panel"
                    role="user-list-panel"
                >
                    <div
                        className={`user-list-heading ${
                            accountList[i].primary_user ? 'user-list-primary-user' : 'user-list-sub-user'
                        }`}
                    >
                        <div
                            className="user-list-icon-wrapper"
                            onMouseEnter={() => this.showTooltip(accountList[i].user_id)}
                            onMouseLeave={() => this.hideTooltip()}
                            onClick={() =>
                                this.setState(({ activeTooltip }) => ({
                                    activeTooltip:
                                        activeTooltip === accountList[i].user_id ? null : accountList[i].user_id,
                                }))
                            }
                        >
                            <span className="fas fa-info-circle user-list-icon" aria-hidden="true"></span>
                            {this.state.activeTooltip === accountList[i].user_id && (
                                <div className="user-list-tooltip" role="tooltip">
                                    <div className="tooltip-inner">{this.renderTooltipContent(accountList[i])}</div>
                                </div>
                            )}
                        </div>
                        <div className="user-list-body" onClick={(e) => this.handleSelectUser(accountList[i].user_id)}>
                            <div>{accountList[i].organization}</div>
                            <div>{accountList[i].role_name}</div>
                        </div>
                        <div onClick={(e) => this.handleSelectUser(accountList[i].user_id)}>
                            <span className="fas fa-chevron-right user-list-icon" aria-hidden="true"></span>
                        </div>
                    </div>
                </div>
            );
        }
        return panels;
    };

    renderTooltipContent = (account) => {
        return (
            <div>
                <div>
                    Name: {account.first_name} {account.last_name}
                </div>
                <div>Email: {account.email}</div>
                <div>Role: {account.role_name}</div>
                <div>Organization: {account.organization}</div>
                <div>
                    Services:
                    <ul>
                        {account.services.map((service, i) => (
                            <li key={`${account.user_id}_service_${i}`}>{service}</li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };

    showTooltip = (userId) => {
        this.setState({ activeTooltip: userId });
    };
}

export default AccountSelector;
